import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

export enum LogType {
  DATA_COLLECTOR_LOG = 'DATA_COLLECTOR_LOG',
  DIAGNOSTICS_LOG = 'DIAGNOSTICS_LOG',
  SECURITY_LOG = 'SECURITY_LOG'
}

export interface RequestGetLogApiCommand {
  logType: LogType;
  retries?: number;
  retryInterval?: number;
  remoteLocation?: string;
  oldestTimestamp?: Date;
  latestTimestamp?: Date;
}

const client = createClient('/rest/operator-api/charging-stations');

export const getLog: SaveOperation<RequestGetLogApiCommand, void, string> = postRequestFactory<
  RequestGetLogApiCommand,
  void,
  string
>(client, { pattern: '/{chargingStationId}/get-log', permissionId: commandPermissions.GET_LOG });
